import { render, staticRenderFns } from "./smartControl_mng.vue?vue&type=template&id=3f66d96b"
import script from "./smartControl_mng.vue?vue&type=script&lang=js"
export * from "./smartControl_mng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f66d96b')) {
      api.createRecord('3f66d96b', component.options)
    } else {
      api.reload('3f66d96b', component.options)
    }
    module.hot.accept("./smartControl_mng.vue?vue&type=template&id=3f66d96b", function () {
      api.rerender('3f66d96b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/smartControl/smartControl_mng.vue"
export default component.exports